import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Courses from "./Courses";
import Users from "./Users";

import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";
import initials from "../../utils/initials";

const SelectedGroup = (props) => {
  const { groups, setGroups, selectedGroup, allCourses, allUsers } = props;

  const [name, setName] = useState("");
  const [errors, setErrors] = useState("");
  const [selectedSetting, setSelectedSetting] = useState("courses");

  useEffect(() => {
    if (selectedGroup) {
      setName(selectedGroup.name);
    }
  }, [selectedGroup]);

  const handleNameChange = async () => {
    if (name === selectedGroup.name) return;

    const validation = validateAttributes(
      {
        name,
      },
      validations,
    );

    setErrors(validation);
    if (validation) return;

    const response = await patchGroup({ name: name });

    if (response.ok) {
      setErrors({});
      const data = await response.json();

      setGroups(
        groups.map((group) =>
          group.id == selectedGroup.id ? data.group : group,
        ),
      );
    } else {
      console.log("error");
    }
  };

  const patchGroup = async (params) => {
    return await fetch("/groups/" + selectedGroup.id, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        group: params,
      }),
    });
  };

  const className = (attribute) => {
    let className = "flex-1 bg-gray-100 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  const buttonClassName = (button) => {
    let className = "pl-6 pr-6 pt-3 pb-3";
    if (selectedSetting === button) {
      className += " text-white bg-primaryYellow500";
    } else {
      className += " text-gray-600 hover:text-black";
    }

    return className;
  };

  return (
    <>
      {selectedGroup && (
        <div
          className="p-6 bg-white font-sans text-sm text-gray-800 w-3/4"
          style={{ maxWidth: "1000px" }}
        >
          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-semibold">
              {initials(selectedGroup.name)}
            </div>
            <h1 className="text-lg font-semibold">{selectedGroup.name}</h1>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex gap-4">
              <span className="w-48 text-gray-500 flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
                  />
                </svg>
                Nazwa
              </span>
              <input
                className={className("name")}
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlurCapture={handleNameChange}
              />
            </div>
            {errorMessage(errors, "name")}
          </div>
          <div className="mt-10">
            <div>
              <button
                className={buttonClassName("courses")}
                onClick={() => setSelectedSetting("courses")}
              >
                Szkolenia
              </button>
              <button
                className={buttonClassName("users")}
                onClick={() => setSelectedSetting("users")}
              >
                Użytkownicy
              </button>
            </div>

            {selectedSetting == "courses" ? (
              <Courses
                group={selectedGroup}
                allCourses={allCourses}
                groups={groups}
                setGroups={setGroups}
              />
            ) : (
              <Users
                group={selectedGroup}
                allUsers={allUsers}
                groups={groups}
                setGroups={setGroups}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectedGroup;

SelectedGroup.propTypes = {
  selectedGroup: PropTypes.object,
  groups: PropTypes.array,
  allCourses: PropTypes.array,
  allUsers: PropTypes.array,
  setGroups: PropTypes.func,
};
